import { useEffect, useState } from "react";
import { useDeleteCartItem } from "src/hooks/useDeleteCartItem";
import { useSetLineItemSupplyChannel } from "src/hooks/useSetLineItemSupplyChannel";
import { Cart } from "src/types/ctgraphql.d";
import { getCartInfo } from "src/utils/ct/cart-helper";

const useValidateLineItemSupplyChannel = (
  cart: Cart | undefined | null,
  setShowWarning: (showWarning: boolean) => void,
  setWarningMessage: (warningMessage: string) => void
): { validating: boolean } => {
  const [validating, setValidating] = useState(true);
  const [noSupplyChannelLineItemId, setNoSupplyChannelLineItemId] =
    useState<string>();

  const isCart = !!cart;
  const lineItem = cart?.lineItems.find(({ supplyChannel }) => !supplyChannel);
  const lineItemSupplyChannelId =
    lineItem?.variant?.availability?.channels?.results?.[0]?.channel?.id;

  const { deleteCartItem } = useDeleteCartItem({
    // refetchQueries: ["cart"],
    onCompleted: () => {
      setWarningMessage(
        "We are sorry, something went wrong and your cart has been updated."
      );
      setShowWarning(true);
    },
  });

  const { setLineItemSupplyChannel } = useSetLineItemSupplyChannel({
    onCompleted: (cartData) => {
      const noSupplyChannelLineItem = cartData.updateMyCart?.lineItems.find(
        ({ id, supplyChannel }) =>
          !supplyChannel && id === noSupplyChannelLineItemId
      );

      if (noSupplyChannelLineItem && cart) {
        void deleteCartItem([noSupplyChannelLineItem.id], getCartInfo(cart));
      }
    },
  });

  useEffect(() => {
    if (!lineItem?.id) {
      return;
    }

    if (lineItemSupplyChannelId) {
      setNoSupplyChannelLineItemId(lineItem.id);
      setLineItemSupplyChannel(
        lineItem.id,
        lineItemSupplyChannelId,
        getCartInfo(cart)
      );
    } else if (cart) {
      void deleteCartItem([lineItem.id], getCartInfo(cart));
    }
  }, [
    cart,
    lineItem?.id,
    lineItemSupplyChannelId,
    deleteCartItem,
    setLineItemSupplyChannel,
  ]);

  useEffect(() => {
    if (isCart && !lineItem?.id) {
      setValidating(false);
    }
  }, [isCart, lineItem?.id]);

  return { validating };
};

export { useValidateLineItemSupplyChannel };
